import PhotoSwipeLightbox from "photoswipe/dist/photoswipe-lightbox.esm.js";
import CloseHandle from "~/static/images/cross_icon.svg?raw";

export default {
  data() {
    return {
      photoSwipeOptions: {
        gallery: null,
        // set background opacity
        bgOpacity: 1,
        padding: {top: 20, bottom: 20, left: 20, right: 20},
        showHideOpacity: true,
        children: 'a',
        // Adjust thumbnail selector,
        // (for opening/closing zoom transition)
        thumbSelector: 'a',
        loop: true,
        showHideAnimationType: 'zoom', /* options: fade, zoom, none */
        initialZoomLevel: 'fit',
        /* Click on image moves to the next slide */
        imageClickAction: 'next',
        tapAction: 'next',

        /* ## Hiding a specific UI element ## */
        zoom: false,
        close: true,
        counter: true,
        arrowKeys: true,
        /* ## Options ## */
        wheelToZoom: true, /* deafult: undefined */
        closeSVG: CloseHandle
      }
    }
  },
  mounted() {
    if (this.photoSwipeActive) {
      this.initPhotoSwipe();
    }
  },
  methods: {
    initPhotoSwipe() {
      this.photoSwipeOptions.gallery = this.galleryID;

      if (!this.isSwiper) {
        this.photoSwipeOptions.counter = false;
        this.photoSwipeOptions.loop = false;
        this.photoSwipeOptions.arrowKeys = false;
        this.photoSwipeOptions.arrowPrev = false;
        this.photoSwipeOptions.arrowNext = false;
        this.photoSwipeOptions.children = '.photoswipe-item';
        this.photoSwipeOptions.thumbSelector = '.photoswipe-item';
        this.photoSwipeOptions.imageClickAction = 'zoom';
        this.photoSwipeOptions.tapAction = 'toggle-controls';

        if (!this.$device.isMobileOrTablet) {
          // Desktop
          this.photoSwipeOptions.padding = {top: 20, bottom: 20, left: 100, right: 100};
        } else if (!this.$device.isMobile) {
          // Tablet
          this.photoSwipeOptions.padding = {top: 20, bottom: 20, left: 40, right: 40};
        }
      }

      const photo_swipe_options = {
        pswpModule: () => import("photoswipe/dist/photoswipe.esm.js"),
        ...this.photoSwipeOptions
      };

      const lightbox = new PhotoSwipeLightbox(photo_swipe_options);

      if (this.swiper) {
        lightbox.on('change', () => {
          const {pswp} = lightbox;
          this.swiper.slideTo(pswp.currIndex, 0, false);
        });

        lightbox.on('closingAnimationStart', () => {
          const {pswp} = lightbox;
          this.swiper.slideTo(pswp.currIndex, 0, false);
        });
      }

      lightbox.init();
    }
  },
};
